import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
import { ECouponCodeStatus } from './CouponCode.js';
var CouponContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: ", "px;\n  width: 100%;\n"], ["\n  display: flex;\n  gap: ", "px;\n  width: 100%;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs2;
});
var CouponInput = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: ", "px;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: ", ";\n  outline: none;\n  background: white;\n  font-size: ", "px;\n  width: 100%;\n  ::placeholder {\n    color: ", ";\n    opacity: 1; /* Firefox */\n  }\n\n  ::-ms-input-placeholder {\n    color: ", ";\n  }\n  ", "\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n"], ["\n  border-radius: ", "px;\n  border: 1px solid ", ";\n  background: ", ";\n  padding: ", ";\n  outline: none;\n  background: white;\n  font-size: ", "px;\n  width: 100%;\n  ::placeholder {\n    color: ", ";\n    opacity: 1; /* Firefox */\n  }\n\n  ::-ms-input-placeholder {\n    color: ", ";\n  }\n  ", "\n  &:focus-visible {\n    border: 1px solid ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a, _b;

  return "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, "px ").concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs2, "px");
}, function (props) {
  var _a, _b;

  return (_b = (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.s3;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.placeholder;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
}, function (props) {
  return !props.customFocus && focusVisible;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlue;
});
var CouponResultContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", "px;\n  padding: ", ";\n  background: ", ";\n  display: flex;\n  min-height: ", "px;\n  border-radius: ", "px;\n  justify-content: space-between;\n  align-items: center;\n  > a {\n    white-space: nowrap;\n  }\n"], ["\n  font-size: ", "px;\n  padding: ", ";\n  background: ", ";\n  display: flex;\n  min-height: ", "px;\n  border-radius: ", "px;\n  justify-content: space-between;\n  align-items: center;\n  > a {\n    white-space: nowrap;\n  }\n"])), function (props) {
  var _a, _b;

  return (_b = (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.s2;
}, function (props) {
  var _a, _b;

  return "".concat((_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.couponContainerPadding, "px ").concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs, "px");
}, function (props) {
  var _a, _b;

  return props.status === ECouponCodeStatus.Success ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.greenLight : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.redLight;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.couponContainerHeight;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
});
var CouponResultMessage = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  gap: ", "px;\n"], ["\n  display: flex;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs2;
});
var CouponInputContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
export { CouponContainer, CouponInput, CouponInputContainer, CouponResultContainer, CouponResultMessage };